import apiHelper from "../../utilities/apiObsHelpers";
import {
  apiAuthenticateUser,
  apiVerifyUserToken
} from "../api/apiObservables";

export const ACTION_AUTHENTICATE_USER       = 'accounts/actionAuthenticateUser';
export const ACTION_VERIFY_TOKEN            = 'accounts/actionVerifyToken';

export const GETTER_AUTHENTICATED_USER      = 'accounts/getAuthenticatedUser';

export const MUTATE_SET_AUTHENTICATED_USER  = 'accounts/setAuthenticatedUser';
export const MUTATE_SET_CURRENT_USER        = 'accounts/setCurrentUser';

const state = {
  authenticatedUser: {},
};

const getters = {
  [GETTER_AUTHENTICATED_USER]: () => state.authenticatedUser,
};

const mutations = {
  [MUTATE_SET_AUTHENTICATED_USER]: (state, payload) => {
    state.authenticatedUser = Object.assign({}, payload)
  }
};

const actions = {
  [ACTION_AUTHENTICATE_USER]: apiHelper.mutateResult(
    apiAuthenticateUser,
    MUTATE_SET_AUTHENTICATED_USER
  ),
  [ACTION_VERIFY_TOKEN]: apiHelper.mutateResult(
    apiVerifyUserToken,
    MUTATE_SET_AUTHENTICATED_USER
  )
};

export default {
  state,
  getters,
  mutations,
  actions
}
